module.exports = __webpack_public_path__ + "img/active-layer6.721fab8b.png";